import React, { useState, useContext, useRef } from 'react';
import SocketContext from '../context/SocketContext';
import UserContext from '../context/UserContext';
import { useNavigate } from 'react-router-dom';

export default function LoginPage() {
  const socket = useContext(SocketContext);
  const [phrase, setPhrase] = useState('');
  const [resp, setResp] = useState(null);
  const [loading, setLoading] = useState(false);
  const { setUser } = useContext(UserContext) || {};
  const navigate = useNavigate();
  const inputRef = useRef(null);

  const submit = async (e) => {
    e && e.preventDefault();
    if (!socket) return setResp({ ok: false, error: 'socket_not_connected' });
    setLoading(true);
    try {
      socket.emit('login', phrase || '', (r) => {
        const result = r || { ok: false, error: 'no_response' };
        setResp(result);
        setLoading(false);
        if (result && result.ok) {
          try { setUser((u) => ({ ...(u || {}), isAdmin: true })); } catch (e) {}
          setTimeout(() => navigate('/'), 450);
        } else {
          // on failure focus the input for convenience
          try { inputRef.current && inputRef.current.focus(); } catch (e) {}
        }
      });
    } catch (e) {
      setLoading(false);
      setResp({ ok: false, error: String(e) });
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-slate-800 to-slate-700 flex items-center justify-center p-6">
      <div className="w-full max-w-md bg-white/5 backdrop-blur-md border border-white/10 rounded-xl shadow-xl p-6">
        <div className="flex items-center gap-3 mb-4">
          <div className="w-12 h-12 rounded-lg bg-indigo-500 flex items-center justify-center text-white font-bold text-lg">A</div>
          <div>
            <h1 className="text-white text-xl font-semibold">Admin Login</h1>
            <p className="text-slate-300 text-sm">Unlock hidden admin controls.</p>
          </div>
        </div>

        <form onSubmit={submit} className="space-y-4" aria-label="Admin login form">
          <div>
            <label htmlFor="phrase" className="block text-sm font-medium text-slate-200">Secret phrase</label>
            <input
              id="phrase"
              ref={inputRef}
              type="password"
              autoComplete="one-time-code"
              value={phrase}
              onChange={(e) => setPhrase(e.target.value)}
              className="mt-1 block w-full rounded-md bg-white/6 border border-white/10 px-3 py-2 text-black placeholder-slate-400 focus:outline-none focus:ring-2 focus:ring-indigo-400"
              placeholder="Enter admin phrase"
            />
            
          </div>

          <div className="flex items-center gap-3">
            <button
              type="submit"
              disabled={loading}
              className="inline-flex items-center justify-center rounded-md bg-indigo-500 px-4 py-2 text-white font-semibold hover:bg-indigo-600 disabled:opacity-60"
            >
              {loading ? 'Checking…' : 'Sign in'}
            </button>

            <button
              type="button"
              onClick={() => navigate('/')}
              className="text-sm text-slate-300 hover:underline"
            >
              Cancel
            </button>
          </div>
        </form>

        <div className="mt-4">
          {resp && resp.ok && (
            <div className="rounded-md bg-emerald-700/20 border border-emerald-400/20 p-3 text-emerald-200">
              <strong className="font-semibold">Success:</strong> You are now an admin for this connection.
            </div>
          )}

          {resp && !resp.ok && (
            <div className="rounded-md bg-rose-700/10 border border-rose-500/10 p-3 text-rose-200">
              <strong className="font-semibold">Error:</strong> {resp.error || 'Unknown error'}
            </div>
          )}
        </div>

        
      </div>
    </div>
  );
}
